import './axiosConfig'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ErrorBoundary } from 'react-error-boundary'
import { Box, Button, Typography } from '@mui/material'
import { store } from './app/store'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './index.css'
import { BrowserRouter } from 'react-router-dom'

const container = document.getElementById('root')!
const root = createRoot(container)

// Root boundary: a render throw anywhere below must degrade to this screen,
// never to a blank white page (2026-07-16 incident).
const RootFallback = () => (
  <Box sx={{ textAlign: 'center', mt: 10, px: 2 }}>
    <Typography variant="h5" gutterBottom>Something went wrong displaying this page.</Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Please reload — if this keeps happening, contact support@rentfinder.ai
    </Typography>
    <Button variant="contained" sx={{ mt: 2 }} onClick={() => window.location.reload()}>Reload</Button>
  </Box>
)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename='/'>
        <ErrorBoundary FallbackComponent={RootFallback}>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
